// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nli[data-v-45b36ca7] {\n  font-size: 1rem;\n  color: black;\n  font-weight: 400;\n}\np[data-v-45b36ca7] {\n  padding: 5px;\n}\n.image-text-frame[data-v-45b36ca7] {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n}\n.image-text-frame[data-v-45b36ca7] .image-wrapper {\n  padding: 5px;\n  padding-right: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
